import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { JhiItemCount, JhiPagination, TextFormat, getPaginationState } from 'react-jhipster';
import { Link, useLocation, useNavigate } from 'react-router';

import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';

import { getEntities } from './callback.reducer';

export const Callback = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const callbackList = useAppSelector(state => state.callback.entities);
  const loading = useAppSelector(state => state.callback.loading);
  const totalItems = useAppSelector(state => state.callback.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const { order } = paginationState;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="callback-heading" data-cy="CallbackHeading">
        Callbacks
        <div className="d-flex justify-content-end">
          <Button className="me-2" variant="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} /> Refresh list
          </Button>
          <Link to="/callback/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp; Create a new Callback
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {callbackList?.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  ID <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('celularCliente')}>
                  Celular Cliente <FontAwesomeIcon icon={getSortIconByFieldName('celularCliente')} />
                </th>
                <th className="hand" onClick={sort('certBdeM')}>
                  Cert Bde M <FontAwesomeIcon icon={getSortIconByFieldName('certBdeM')} />
                </th>
                <th className="hand" onClick={sort('certComercioProveedor')}>
                  Cert Comercio Proveedor <FontAwesomeIcon icon={getSortIconByFieldName('certComercioProveedor')} />
                </th>
                <th className="hand" onClick={sort('claveInstitucionCliente')}>
                  Clave Institucion Cliente <FontAwesomeIcon icon={getSortIconByFieldName('claveInstitucionCliente')} />
                </th>
                <th className="hand" onClick={sort('claveRastreo')}>
                  Clave Rastreo <FontAwesomeIcon icon={getSortIconByFieldName('claveRastreo')} />
                </th>
                <th className="hand" onClick={sort('concepto')}>
                  Concepto <FontAwesomeIcon icon={getSortIconByFieldName('concepto')} />
                </th>
                <th className="hand" onClick={sort('digitoVerificadorCliente')}>
                  Digito Verificador Cliente <FontAwesomeIcon icon={getSortIconByFieldName('digitoVerificadorCliente')} />
                </th>
                <th className="hand" onClick={sort('horaEnvioMensaje')}>
                  Hora Envio Mensaje <FontAwesomeIcon icon={getSortIconByFieldName('horaEnvioMensaje')} />
                </th>
                <th className="hand" onClick={sort('horaProcMensajeCobro')}>
                  Hora Proc Mensaje Cobro <FontAwesomeIcon icon={getSortIconByFieldName('horaProcMensajeCobro')} />
                </th>
                <th className="hand" onClick={sort('horaSolicitudMensajeCobro')}>
                  Hora Solicitud Mensaje Cobro <FontAwesomeIcon icon={getSortIconByFieldName('horaSolicitudMensajeCobro')} />
                </th>
                <th className="hand" onClick={sort('idMensajeCobro')}>
                  Id Mensaje Cobro <FontAwesomeIcon icon={getSortIconByFieldName('idMensajeCobro')} />
                </th>
                <th className="hand" onClick={sort('monto')}>
                  Monto <FontAwesomeIcon icon={getSortIconByFieldName('monto')} />
                </th>
                <th className="hand" onClick={sort('nombreCliente')}>
                  Nombre Cliente <FontAwesomeIcon icon={getSortIconByFieldName('nombreCliente')} />
                </th>
                <th className="hand" onClick={sort('numeroCuentaCliente')}>
                  Numero Cuenta Cliente <FontAwesomeIcon icon={getSortIconByFieldName('numeroCuentaCliente')} />
                </th>
                <th className="hand" onClick={sort('resultadoMensajeCobro')}>
                  Resultado Mensaje Cobro <FontAwesomeIcon icon={getSortIconByFieldName('resultadoMensajeCobro')} />
                </th>
                <th className="hand" onClick={sort('tipoCuentaCliente')}>
                  Tipo Cuenta Cliente <FontAwesomeIcon icon={getSortIconByFieldName('tipoCuentaCliente')} />
                </th>
                <th className="hand" onClick={sort('selloDigital')}>
                  Sello Digital <FontAwesomeIcon icon={getSortIconByFieldName('selloDigital')} />
                </th>
                <th className="hand" onClick={sort('timestampRecibido')}>
                  Timestamp Recibido <FontAwesomeIcon icon={getSortIconByFieldName('timestampRecibido')} />
                </th>
                <th className="hand" onClick={sort('extra1')}>
                  Extra 1 <FontAwesomeIcon icon={getSortIconByFieldName('extra1')} />
                </th>
                <th className="hand" onClick={sort('extra2')}>
                  Extra 2 <FontAwesomeIcon icon={getSortIconByFieldName('extra2')} />
                </th>
                <th className="hand" onClick={sort('extra3')}>
                  Extra 3 <FontAwesomeIcon icon={getSortIconByFieldName('extra3')} />
                </th>
                <th className="hand" onClick={sort('extra4')}>
                  Extra 4 <FontAwesomeIcon icon={getSortIconByFieldName('extra4')} />
                </th>
                <th className="hand" onClick={sort('extra5')}>
                  Extra 5 <FontAwesomeIcon icon={getSortIconByFieldName('extra5')} />
                </th>
                <th className="hand" onClick={sort('extra6')}>
                  Extra 6 <FontAwesomeIcon icon={getSortIconByFieldName('extra6')} />
                </th>
                <th className="hand" onClick={sort('extra7')}>
                  Extra 7 <FontAwesomeIcon icon={getSortIconByFieldName('extra7')} />
                </th>
                <th className="hand" onClick={sort('extra8')}>
                  Extra 8 <FontAwesomeIcon icon={getSortIconByFieldName('extra8')} />
                </th>
                <th className="hand" onClick={sort('extra9')}>
                  Extra 9 <FontAwesomeIcon icon={getSortIconByFieldName('extra9')} />
                </th>
                <th className="hand" onClick={sort('extra10')}>
                  Extra 10 <FontAwesomeIcon icon={getSortIconByFieldName('extra10')} />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  Created Date <FontAwesomeIcon icon={getSortIconByFieldName('createdDate')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {callbackList.map(callback => (
                <tr key={`entity-${callback.id}`} data-cy="entityTable">
                  <td>
                    <Button as={Link as any} to={`/callback/${callback.id}`} variant="link" size="sm">
                      {callback.id}
                    </Button>
                  </td>
                  <td>{callback.celularCliente}</td>
                  <td>{callback.certBdeM}</td>
                  <td>{callback.certComercioProveedor}</td>
                  <td>{callback.claveInstitucionCliente}</td>
                  <td>{callback.claveRastreo}</td>
                  <td>{callback.concepto}</td>
                  <td>{callback.digitoVerificadorCliente}</td>
                  <td>
                    {callback.horaEnvioMensaje ? (
                      <TextFormat type="date" value={callback.horaEnvioMensaje} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {callback.horaProcMensajeCobro ? (
                      <TextFormat type="date" value={callback.horaProcMensajeCobro} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {callback.horaSolicitudMensajeCobro ? (
                      <TextFormat type="date" value={callback.horaSolicitudMensajeCobro} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{callback.idMensajeCobro}</td>
                  <td>{callback.monto}</td>
                  <td>{callback.nombreCliente}</td>
                  <td>{callback.numeroCuentaCliente}</td>
                  <td>{callback.resultadoMensajeCobro}</td>
                  <td>{callback.tipoCuentaCliente}</td>
                  <td>{callback.selloDigital}</td>
                  <td>
                    {callback.timestampRecibido ? (
                      <TextFormat type="date" value={callback.timestampRecibido} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{callback.extra1}</td>
                  <td>{callback.extra2}</td>
                  <td>{callback.extra3}</td>
                  <td>{callback.extra4}</td>
                  <td>{callback.extra5}</td>
                  <td>{callback.extra6}</td>
                  <td>{callback.extra7}</td>
                  <td>{callback.extra8}</td>
                  <td>{callback.extra9}</td>
                  <td>{callback.extra10}</td>
                  <td>{callback.createdDate ? <TextFormat type="date" value={callback.createdDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button as={Link as any} to={`/callback/${callback.id}`} variant="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button
                        as={Link as any}
                        to={`/callback/${callback.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        variant="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button
                        onClick={() =>
                          (globalThis.location.href = `/callback/${callback.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        variant="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Callbacks found</div>
        )}
      </div>
      {totalItems ? (
        <div className={callbackList && callbackList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Callback;
